import { render, staticRenderFns } from "./OpenChat.vue?vue&type=template&id=afd98220"
import script from "./OpenChat.vue?vue&type=script&lang=js"
export * from "./OpenChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports